<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title mt10">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                客户信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item" v-if="confirmOrderInfo.Apply_SN">
                        <div class="label">报价单编号：</div>
                        <div class="content">{{ confirmOrderInfo.Apply_SN }}</div>
                    </div>

                    <div class="info-item" v-if="Orders_SourceCate == 1">
                        <div class="label">ERP订单：</div>
                        <div class="content">{{ confirmOrderInfo.ERP_SN }}</div>
                    </div>
                    <div class="info-item">
                        <div class="label">合同类型：</div>
                        <div class="content">{{ Orders_Type == 0 ? '销售合同' : Customer_info.Orders_Type == 1 ? '服务合同' : '' }}</div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="PipelineCustomer.ID">
                            <div class="label">商机编号：</div>
                            <div class="content">{{ PipelineCustomer.ID + ' [' + PipelineCustomer.opportunityName + ']' }}</div>
                        </div>
                    </div>
                    <div class="flex" v-if="Customer_info.Customer_Type == '0'">
                        <div class="info-item">
                            <div class="label">客户编号：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户名称：</div>
                            <div class="content">{{ Customer_info.Customer_Name }}</div>
                        </div>
                    </div>
                    <div class="flex" v-else>
                        <div class="info-item">
                            <div class="label">客户姓名：</div>
                            <div class="content label-middle">{{ Customer_info.Person_Name }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户手机：</div>
                            <div class="content">{{ Customer_info.Person_Mobile }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户类型：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Type == '0' ? '企业客户' : '个人客户' }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == 0">
                            <div class="label">注册所在地：</div>
                            <div class="content">{{ Customer_info.Customer_RegAddr }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title mt10" v-if="TradeType == 1">纸质合同编号</div>
            <el-form-item :label="PaperContractSNPlace" label-width="110px" v-if="TradeType == 1">
                <el-input disabled class="el-select-big" v-model="confirmOrderInfo.Orders_PaperContractSN" placeholder="请输入纸质合同编号"></el-input>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                工程信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程区域：</div>
                            <div class="content">{{ confirmOrderInfo.Customer_Project_Site_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程名称：</div>
                            <div class="content">{{ confirmOrderInfo.Customer_Project_Name }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">行业分类 :</div>
                        <div class="content">{{ displayProjectTypeName }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                合同联系人
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系人姓名：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Contract_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系人手机：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Contract_Mobile }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系人邮箱：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Contract_Email }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">短信通知：</div>
                        <div class="content">
                            <span v-if="confirmOrderInfo.Orders_MsgNotify == 0 && confirmOrderInfo.Orders_MsgNotify1 == 0">均不通知</span>
                            <span v-if="confirmOrderInfo.Orders_MsgNotify == 1 && confirmOrderInfo.Orders_MsgNotify1 == 0">客户</span>
                            <span v-if="confirmOrderInfo.Orders_MsgNotify == 0 && confirmOrderInfo.Orders_MsgNotify1 == 1">业务员</span>
                            <span v-if="confirmOrderInfo.Orders_MsgNotify == 1 && confirmOrderInfo.Orders_MsgNotify1 == 1">客户 &nbsp;业务员</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title" v-show="IsHonly == 0">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配送方式
            </div>
            <div class="info" v-show="IsHonly == 0">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">配送方式：</div>
                        <div class="content" v-if="confirmOrderInfo.Orders_Delivery_ID == 4">供方指定</div>
                        <div class="content" v-else-if="confirmOrderInfo.Orders_Delivery_ID == 1">
                            <span>自提</span>
                            <span class="tip ml10">提货前请联系中转库是否满足提货条件</span>
                        </div>
                        <div class="content" v-else-if="confirmOrderInfo.Orders_Delivery_ID == 2">
                            <span>其他</span>
                            <span class="tip ml10">{{confirmOrderInfo.delivery_name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配送信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">配送地址：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_Site_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">收货地址：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_StreetAddress }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">地址类型：</div>
                            <div class="content">{{ confirmOrderInfo.AddressType == 'Y' ? '客户地址' : '办事处地址' }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">邮编：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_Zip }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">收货人姓名：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系电话：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_Phone_Number }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">手机：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_Address_Mobile }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">业务员：</div>
                        <div class="content">{{ confirmOrderInfo.Orders_OfficeManName }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                付款方式
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">付款方式：</div>
                        <div class="content">{{ submitpaymentObj.value }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                支付方式：
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">支付方式：</div>
                        <div class="content">【待付款】{{ confirmOrderInfo.Orders_Payway_Name }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                配电柜厂家
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">配电柜厂家：</div>
                        <div class="content">{{ confirmOrderInfo.CabinetSupplierName }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                发货信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex" v-show="IsHonly == 0">
                        <div class="info-item">
                            <div class="label">发货类型：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_IsAllFreight == 1 ? '整单发货' : '分批发货' }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">发货方式：</div>
                            <div class="content">
                                <span>{{ confirmOrderInfo.Orders_FreightType == 1 ? '审核订单后发货' : '即时发货' }}</span>
                                <el-checkbox-group v-if="confirmOrderInfo.Orders_IsPayAuditDelivery_Type == 'checkbox'" v-model="Orders_IsPayAuditDelivery" class="mt10">
                                    <el-checkbox label="1" name="type">
                                        <span>付款审核后直接发货</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <span class="tip" v-if="confirmOrderInfo.Orders_IsAllReach">【所有货物必须一次发货】</span>
                                <span class="tip">一次发货需待所有货物备齐后统一发货，发货周期可能会延长</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex" v-show="IsHonly == 0">
                        <div class="info-item">
                            <div class="label">交货时间：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_DeliveryTime }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">期望交货时间：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_PlanDeliveryDate | formatDate }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="isReturnGoods != 1">
                            <div class="label">合同其他约定：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_OtherAgreement }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">合同备注:</div>
                        <div class="content">{{ confirmOrderInfo.order_note }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title" v-if="Orders_SourceCate != 1 && isShowProjectType">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                项目类型
            </div>
            <div class="info" v-if="Orders_SourceCate != 1 && isShowProjectType">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">项目类型：</div>
                        <div class="content">{{ confirmOrderInfo.Orders_ProjectType == 1 ? '新建项目' : '已建项目(升级改造)' }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title" v-if="(Orders_SourceCate == 1 || (Orders_SourceCate != 1 && TradeType != 1)) && TradeType != 1">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                电子签章
            </div>
            <el-form-item label="电子签章：" v-if="(Orders_SourceCate == 1 || (Orders_SourceCate != 1 && TradeType != 1)) && TradeType != 1">
                <el-radio-group v-model="Orders_ESignStatus">
                    <el-radio label="1">不使用</el-radio>
                    <el-radio label="2">使用</el-radio>
                </el-radio-group>
                <el-tag type="success" class="ml10" v-if="Customer_info.Customer_IsESign == 1">已注册电子签章</el-tag>
                <el-tag type="warning" class="ml10" v-else>未注册电子签章</el-tag>
                <div class="" v-if="Customer_info.Customer_Type != 0">
                    <div class="u-m-t-20">
                        {{ Orders_ESignName }}
                    </div>
                    <div class="u-m-t-20">
                        {{ Orders_EsignMobile }}
                    </div>
                </div>
                <div class="" v-else>
                    <div class="u-m-t-20 mt10 mb10">
                        <el-input v-model="Orders_ESignName" type="text" class="el-select-big" placeholder="联系人姓名" />
                    </div>
                    <div class="u-m-t-20 mt10 mb10">
                        <el-input v-model="Orders_EsignMobile" type="text" class="el-select-big" placeholder="联系人手机" />
                    </div>
                </div>
            </el-form-item>
            <div class="form-title" v-if="isReturnGoods != 1 && performanceList && performanceList.length > 0">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                异地业绩划分
            </div>
            <el-table :data="performanceList" v-if="isReturnGoods != 1 && performanceList && performanceList.length > 0" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <el-table-column type="index" label="" align="center">
                    <template v-slot="scope">
                        <el-checkbox :disabled="scope.$index == 0" v-model="scope.row.checked"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="IsMainMember" label="异地说明" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="OfficeCode" label="分支机构" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="OfficeMemberName" label="目标用户" align="center" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span v-if="scope.$index == 0">{{ scope.row.OfficeMemberName }}</span>
                        <el-select v-else v-model="scope.row.OfficeMemberID" placeholder="请选择目标用户">
                            <el-option v-for="item in scope.row.officeMemberList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="分配比例" align="center" show-overflow-tooltip>
                    <template v-slot="scope">
                        <el-input v-model="scope.row.Rate" type="number" placeholder="填写分配比例%" />
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 10px" v-if="isReturnGoods != 1 && performanceList && performanceList.length > 0">
                备注说明：
                <el-input v-model="performance_note" placeholder="当业绩划分比例存在为0时，必填" style="width: 20%"></el-input>
            </div>
            <div class="form-title" v-if="confirmOrderInfo.freightlimitdiscount == 2">发货管控送审原因</div>
            <el-form-item label="选择原因：" v-if="confirmOrderInfo.freightlimitdiscount == 2">
                <el-checkbox-group v-model="Orders_FreightLimitReasonList">
                    <el-checkbox :label="item.name" v-for="(item, index) in freightLimitList" :key="index">{{ item.value }}</el-checkbox>
                </el-checkbox-group>
                <div class="" v-if="Orders_FreightLimitReasonList.includes('RO')">
                    <div class="u-m-t-20 mt10 mb10">
                        <el-input v-model="Orders_FreightLimitReasonNote" type="text" class="el-select-big" placeholder="" />
                        最多不超过100个字符
                        <font style="color: #ff0000">*</font>
                    </div>
                </div>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                商品清单
            </div>
            <div v-if="Orders_SourceCate == 2">
                <div class="cart-list-container" v-if="cartList && cartList.length > 0">
                    <div class="cart-list" v-for="(item, index) in cartList" :key="index">
                        <div class="flex">
                            <div class="cart-top-title-big mr10">
                                <span>{{ item.DiscountCateName }}</span>
                            </div>
                        </div>
                        <div v-for="items in item.List" :key="items.ID">
                            <div class="">
                                <div class="cart-top-title-big" v-if="items.DiscountCateName">
                                    <span>{{ items.DiscountCateName || '--' }}</span>
                                </div>
                            </div>
                            <div>
                                <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                    <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>

                                    <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                    <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_AdjustDiscountPrice" label="折扣价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_AdjustDiscountPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                    <el-table-column prop="Goods_DeliveryAmount" label="发货数量" align="center" width="120" v-if="confirmOrderInfo.Orders_IsAllFreight == 0 && confirmOrderInfo.Orders_FreightType == 0">
                                        <template v-slot="scope">
                                            <el-input v-if="scope.row.Goods_DeliveryAmountInput == 'true'" v-model="scope.row.Goods_DeliveryAmount" type="number" placeholder="填写发货数量" />
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="cart-list-container mt20" v-if="activityCartList && activityCartList.length > 0">
                    <div class="form-title" style="margin-top: 0">
                        <svg-icon icon-class="lm" class-name="lm-icon" />
                        促销商品
                    </div>
                    <div class="cart-list" v-for="(item, index) in activityCartList" :key="index">
                        <div class="flex">
                            <div class="cart-top-title-big mr10">
                                <span>{{ item.DiscountCateName }}</span>
                            </div>
                        </div>
                        <div v-for="items in item.List" :key="items.ID">
                            <div class="">
                                <div class="cart-top-title-big" v-if="items.DiscountCateName">
                                    <span>{{ items.DiscountCateName || '--' }}</span>
                                </div>
                            </div>
                            <div>
                                <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                    <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>

                                    <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                    <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Product_AdjustDiscountPrice" label="折扣价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_Product_AdjustDiscountPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                    <el-table-column prop="Goods_DeliveryAmount" label="发货数量" align="center" width="120" v-if="confirmOrderInfo.Orders_IsAllFreight == 0 && confirmOrderInfo.Orders_FreightType == 0">
                                        <template v-slot="scope">
                                            <el-input v-if="scope.row.Goods_DeliveryAmountInput == 'true'" v-model="scope.row.Goods_DeliveryAmount" type="number" placeholder="填写发货数量" />
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                        <template v-slot="scope">
                                            <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="total">
                    商品金额合计:
                    <span>￥{{ Total_Price || 0 }}</span>
                </div>
                 <div class="total">
                     <span>{{ warrantyExtendResultTip }}</span>
                </div>
            </div>
            <div v-else>
                <div class="cart-list-container" v-if="cartList && cartList.length > 0">
                    <div class="cart-list" v-for="(item, index) in cartList" :key="index">
                        <div class="flex">
                            <div class="cart-top-title-big mr10">
                                <span>{{ item.DiscountCateName }}</span>
                            </div>
                        </div>
                        <div>
                            <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column align="center" width="50px">
                                    <template v-slot="scope">
                                        <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>

                                <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                <el-table-column prop="Goods_DeliveryAmount" label="发货数量" align="center" width="120" v-if="confirmOrderInfo.Orders_IsAllFreight == 0 && confirmOrderInfo.Orders_FreightType == 0">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.Goods_DeliveryAmountInput == 'true'" v-model="scope.row.Goods_DeliveryAmount" type="number" placeholder="填写发货数量" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="折扣价" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_DiscountPrice }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="cart-list-container" v-if="activityCartList && activityCartList.length > 0">
                    <div class="cart-list" v-for="(item, index) in activityCartList" :key="index">
                        <div>
                            <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column align="center" width="50px">
                                    <template v-slot="scope">
                                        <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                                <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>

                                <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                                <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                <el-table-column prop="Goods_DeliveryAmount" label="发货数量" align="center" width="120" v-if="confirmOrderInfo.Orders_IsAllFreight == 0 && confirmOrderInfo.Orders_FreightType == 0">
                                    <template v-slot="scope">
                                        <el-input v-if="scope.row.Goods_DeliveryAmountInput == 'true'" v-model="scope.row.Goods_DeliveryAmount" type="number" placeholder="填写发货数量" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_Product_DiscountPrice" label="折扣价" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_Product_DiscountPrice }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140">
                                    <template v-slot="scope">
                                        <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="total">
                            商品金额合计:
                            <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                            订单金额:
                            <span>￥{{ item.Orders_Price || 0 }}</span>
                            折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                            <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                        </div>
                    </div>
                </div>
                <div class="total">
                    商品金额合计:
                    <span>￥{{ Total_Price || 0 }}</span>
                </div>
                <div class="total">
                     <span>{{ warrantyExtendResultTip }}</span>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        submitpaymentObj: {
            type: Object,
            default: () => ({})
        },
        // 商机信息
        PipelineCustomer: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: Number,
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: Number,
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: [Number, String],
            default: 2
        },
        cartList: {
            type: Array,
            default: () => []
        },
        activityCartList: {
            type: Array,
            default: () => []
        },
        isReturnGoods: {
            type: [Number, String],
            default: 0
        },
        // 商品总金额
        Total_Price: {
            type: [Number, String],
            default: 0
        },
        // 判断是否仅人工费
        IsHonly: {
            type: [Number, String],
            default: 0
        },
        // 是否显示项目类型
        isShowProjectType: {
            type: Boolean,
            default: false
        }
    },
    mounted() {},
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        }),
        // 显示行业分类名称，如果为空则显示占位符
        displayProjectTypeName() {
            return this.confirmOrderInfo.Orders_ProjectType_Name || '--';
        }
    },
    data() {
        return {
            cityListopt: [], //城市list
            districtListopt: [], //区县list

            officeManID: '',
            offinceList: [],

            SupplierList: [],

            Orders_ESignStatus: '', // 电子签章状态
            Orders_ESignName: '', // 电子签章名称
            Orders_EsignMobile: '', // 电子签章手机
            performanceList: [], //业绩划分列表
            performance_note: '', //业绩划分备注说明
            Orders_IsPayAuditDelivery: [], //  1付款审核后直接发货 0付款审核后不直接发货
            confirmOrderInfo: '', //合同确认页面参数
            PaperContractSNPlace: 'GST-' + new Date().getFullYear() + '-No.',
            confirmOrderInfo: {
                // orders_id: -1,
                // Orders_type: 0,
                // Orders_SourceCate: 2,
                // apply_id: "",
                // orders_target: 1,
                // isconfirm: "",
                // orders_copy: 0,
                // paperorders: 2,
                // Orders_Attachment: "",
                // Orders_ApprovalAttachment: "",
                // cartgoods: "0,8831991|2",
                // Orders_PayType_ID: 1,
                // paytype_name: "先款后货",
                // prepay_percent: "",
                // nextpay_days: "",
                // second_percent: "",
                // third_percent: "",
                // retention_percent: "",
                // Expired_PayDate: "",
                // Orders_BuyerID: "1513",
                // member_id: "1513",
                // customer_id: "1543",
                // Customer_Sub_ID: "",
                // Customer_Name: "上海睿熙智能科技有限公司",
                // Customer_Mobile: "",
                // Orders_PaperContractSN: "",
                // Customer_Project_Country: "1",
                // Customer_Project_State: "1",
                // Customer_Project_City: "356",
                // Customer_Project_County: "3267",
                // Customer_Project_Name: "前缀主体工程后缀",
                // customer_project_name: "主体工程",
                // Orders_ProjectType_ID: 1,
                // Orders_OfficeManID: 1343,
                // Orders_OfficeManName: "[00000700009]孟健",
                // CabinetSupplier: "241",
                // CabinetSupplierName: "廊坊市洋普电气有限公司[河北省 廊坊 安次区   杨税务镇大北尹村后街村委会西中国移动塔下洋普电气公司]",
                // Orders_Contract_Name: "大番薯",
                // Orders_Contract_Mobile: "18435207945",
                // Orders_Contract_Email: "179028026@qq.com",
                // Orders_MsgNotify: 0,
                // Orders_MsgNotify1: 0,
                // Orders_Address_ID: "",
                // Orders_Address_Country: "1",
                // Orders_Address_State: "2",
                // Orders_Address_City: "377",
                // Orders_Address_County: "3292",
                // Orders_Address_StreetAddress: "万和",
                // Orders_Address_Zip: "042100",
                // Orders_Address_Mobile: "",
                // Orders_Address_Name: "收货大番薯",
                // Orders_Address_Phone_Number: "18435207945",
                // AddressType: "Y",
                // order_note: "订单备注",
                // Invoice_ID: "",
                // admin_note: "",
                // Orders_Delivery_ID: "4",
                // delivery_name: "",
                // Orders_DeliveryTime: "2025-05-10",
                // Orders_PlanDeliveryDate: "2025-05-15",
                // Orders_IsAllFreight: "1",
                // Orders_IsAllReach: 0,
                // Orders_FreightType: "1",
                // Orders_IsPayAuditDelivery: 0,
                // Orders_CustomerPartA: "",
                // Orders_OtherAgreement: "合同其它约定",
                // Orders_ProjectType: "1",
                // Orders_ProjectNote: "",
                // SessionID: "",
                // discountprice_8831991: 1023,
                // SPCApply_AdderID: ""
            },
            freightLimitList: [], // 发货管控送审原因
            Orders_FreightLimitReasonList: [], //选中发货管控送审原因
            Orders_FreightLimitReasonNote: '', //发货管控送审其他原因
            warrantyExtendResultTip: '', //延保提示信息
        };
    },
    methods: {
        // 处理前置条件
        precondition() {
            if (this.Customer_info.Customer_Type == 1) {
                this.confirmOrderInfo.Orders_Contract_Name = this.Customer_info.Person_Name;
                this.confirmOrderInfo.Orders_Contract_Mobile = this.Customer_info.Person_Mobile;
            }
        },
        // 计算折扣 销售合同
        userComputer1() {
            var obj = {};
            var list = this.cartList.concat(this.activityCartList);
            for (let i = 0; i < list.length; i++) {
                if (list[i].DiscountShow) {
                    if (i < this.cartList.length) {
                        obj['discountrate_' + list[i].DiscountCateID] = list[i].inputValue; //订单折扣
                    }
                }
                for (let k = 0; k < list[i].List.length; k++) {
                    if (list[i].List[k].DiscountShow) {
                        if (i < this.cartList.length) {
                            obj['discountrate_' + list[i].List[k].DiscountCateID] = list[i].List[k].inputValue; //分类折扣
                        }
                    }
                    var cartId = [];
                    for (let j = 0; j < list[i].List[k].Goods.length; j++) {
                        if (list[i].List[k].Goods[j].checked) {
                            cartId.push(list[i].List[k].Goods[j].Goods_ID);
                        }
                        if (list[i].DiscountShow) {
                            if (i < this.cartList.length) {
                                obj['discountgoods_' + list[i].DiscountCateID] = cartId.join(); //选中的商品
                            }
                        } else {
                            if (i < this.cartList.length) {
                                obj['discountgoods_' + list[i].List[k].DiscountCateID] = cartId.join(); //选中的商品
                            }
                        }
                        obj['discountprice_' + list[i].List[k].Goods[j].Goods_ID] = list[i].List[k].Goods[j].Goods_Product_AdjustDiscountPrice; //选中的商品
                    }
                }
            }
            this.$emit('userComputer', obj);
        },
        // 合同确认页面方法
        async comfirmSpcOrderMethos(orderInfo) {
            if (orderInfo.Orders_IsPayAuditDelivery_Type == 'checkbox' && this.Orders_SourceCate != 1) {
                this.$confirm('是否在付款审核通过后立即发货？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        orderInfo.Orders_IsPayAuditDelivery = 1;
                        this.Orders_IsPayAuditDelivery = ['1'];
                    })
                    .catch(() => {
                        orderInfo.Orders_IsPayAuditDelivery = 0;
                        this.Orders_IsPayAuditDelivery = ['0'];
                    });
            } else if (orderInfo.Orders_IsPayAuditDelivery_Type == 'hidden') {
                orderInfo.Orders_IsPayAuditDelivery = 1;
                this.Orders_IsPayAuditDelivery = ['1'];
            } else {
                orderInfo.Orders_IsPayAuditDelivery = 0;
                this.Orders_IsPayAuditDelivery = ['0'];
            }
            this.Orders_ESignName = orderInfo.Orders_Contract_Name;
            this.Orders_EsignMobile = orderInfo.Orders_Contract_Mobile;
            this.confirmOrderInfo = orderInfo;
            console.log('orderInfo', orderInfo);
            console.log('this.confirmOrderInfo', this.confirmOrderInfo);
            this.performanceDistributeForm();
            this.GetBPMAuditReason();
            // 获取延保提示信息
            this.GetWarrantyExtendResultTip(orderInfo);
        },
        // 提取合同确认页面参数
        getSpcOrderConfirmParams() {
            let json = this.confirmOrderInfo;
            // 提取业绩划分参数
            var ListTwo = this.performanceList;
            var objTwo = {};
            let POffice_ID = [];
            for (let i = 0; i < ListTwo.length; i++) {
                if (ListTwo[i].checked) {
                    POffice_ID.push(ListTwo[i].OfficeID);
                }
            }
            objTwo.POffice_ID = POffice_ID.join();
            for (let i = 0; i < ListTwo.length; i++) {
                if (ListTwo[i].checked) {
                    objTwo['performance_' + ListTwo[i].OfficeID] = ListTwo[i].Rate || 0;
                    objTwo['Poffice_ManID_' + ListTwo[i].OfficeID] = ListTwo[i].OfficeMemberID;
                }
            }
            // 将objTwo合并到 orderInfo里面
            for (var key in objTwo) {
                json[key] = objTwo[key];
            }
            // 将业绩划分备注合并
            json.performance_note = this.performance_note;
            json.addrchangereason = this.addrchangereason;
            json.isconfirm = 1;
            json.orders_target = 1;

            // 签章状态
            json.Orders_ESignStatus = this.Orders_ESignStatus;
            json.Orders_ESignName = this.Orders_ESignName;
            json.Orders_EsignMobile = this.Orders_EsignMobile;
            json.Customer_IsESign = this.Customer_info.Customer_IsESign;

            // 发货管控送审原因
            if (json.freightlimitdiscount == 2) {
                json.Orders_FreightLimitReason = this.Orders_FreightLimitReasonList.join(',');
                json.Orders_FreightLimitReasonNote = this.Orders_FreightLimitReasonNote;
            }
            return json;
        },
        // 业绩划分列表
        async performanceDistributeForm() {
            var result = await this.$newsApi.order.PerformanceDistributeForm({
                projectcountry: this.confirmOrderInfo.Customer_Project_Country,
                projectstatecode: this.confirmOrderInfo.Customer_Project_State,
                projectcitycode: this.confirmOrderInfo.Customer_Project_City,
                addrcountry: '1',
                addrstatecode: this.confirmOrderInfo.Orders_Address_State,
                addrcitycode: this.confirmOrderInfo.Orders_Address_City,
                OfficeManID: this.confirmOrderInfo.Orders_OfficeManID
            });
            result.data = result.data.data;
            if (result.data) {
                result.data.map((item) => {
                    item.checked = false;
                });
                result.data[0].checked = true;
                // 处理数据信息
                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].Dic) {
                        var officeMemberList = [];
                        for (var key in result.data[i].Dic) {
                            var obj = {};
                            obj.id = key;
                            obj.name = result.data[i].Dic[key];
                            officeMemberList.push(obj);
                        }
                        result.data[i].officeMemberList = officeMemberList;
                        result.data[i].OfficeMemberID = officeMemberList[0].id;
                    }
                }
                this.performanceList = result.data;
            } else {
                this.performanceList = [];
            }
        },
        async GetBPMAuditReason() {
            let result = await this.$newsApi.order.GetBPMAuditReason();
            this.freightLimitList = Object.entries(result.data.data).map(([name, value]) => ({ name, value }));
        },
           // 获取延保提示信息
        async GetWarrantyExtendResultTip(orderInfo) {
            let json = JSON.stringify(orderInfo);
            let result = await this.$newsApi.order.GetWarrantyExtendResultTip({
                json: json,
                ispreview: 'true',
                Orders_ID: orderInfo.orders_id,
                Orders_type: 0,
                Orders_BuyerID: orderInfo.Orders_BuyerID,
                ifBack: true
            });
            if (result.data && result.data.data && result.data.data.tip) {
                this.warrantyExtendResultTip = result.data.data.tip;
            }
        },
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon {
    margin-right: 10px;
}
.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}
.flex {
    display: flex;
    align-items: center;
}
.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 100px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.moneyRed {
    font-weight: 700;
    color: red;
}
</style>
